<template lang="pug">
  Wrapper.q-px-lg.q-py-xl
    h5.q-mb-xl Booking History Report
    .filter.q-mb-md.bg-gray.flex.justify-between
      .container-fluid.overflow-auto
        .row.items-center.q-col-gutter-md
          .col-lg-6.col-xl-4
            md-datepicker(v-model="from" md-immediately)
              label From (Date Issued)
          .col-lg-6.col-xl-4
            md-datepicker(v-model="to" md-immediately)
              label To (Date Issued)
    .export.q-mb-md.bg-gray
      .container-fluid.overflow-auto
        .row.q-col-gutter-md
          .col-lg-6.col-xl-4
            md-field
              label Account / Company
              md-input(v-model="search")
              md-icon.md-primary search
          .col-lg-6.col-xl-4
            md-field
                label Sort:
                md-select(v-model="sort")
                  md-option(value="newest") Newest
          .finder.col-lg-4.offset-lg-8.offset-xl-0
            span.flex.items-center
              md-icon.icon print
              span.q-mr-md.icon-label Print
            span.flex.items-center
              md-icon.icon keyboard_capslock
              span.q-mr-md.icon-label Export
    .q-mb-md.content-wrapper
      .summary-info.q-pa-md
        h5 Booking History Report
        p.text-muted.q-ma-none Date: 23 / 11 / 2016 - 14 / 12 / 2016
        p.q-ma-none 1234 Logistics Co.,Ltd.
        p.text-muted.q-ma-none Total Bookings: 4
      .container-fluid.q-px-none
        .row
          md-table.full-width
            md-table-row.table-header
              md-table-head Booking Date
              md-table-head Booking ID
              md-table-head Total Booking
              md-table-head Vsl / Voy
              md-table-head Container
              md-table-head Total Chargable
              md-table-head Price
            md-table-row(v-for="booking in bookings" :key="booking.bookingId").table-row
              md-table-cell {{ booking.date }}
              md-table-cell {{ booking.bookingId }}
              md-table-cell {{ booking.totalBookings }}
              md-table-cell {{ booking.voyage }}
              md-table-cell {{ booking.container }}
              md-table-cell {{ booking.totalChargable }}
              md-table-cell ${{ booking.price }}
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import formatDateMixin from '@/utils/mixins/formatDateMixin';

const fake = [
  {
    date: '23/11/2016',
    bookingId: 'VWST1104055',
    totalBookings: 3,
    voyage: 'CMA CGM VERDI 6043',
    container: 'CMAU2009336',
    totalChargable: 3,
    price: '31.80',
  },
];

export default {
  name: 'AdminRFQ',

  components: {
    Wrapper,
  },

  mixins: [formatDateMixin],

  data() {
    return {
      currentPage: 1,
      pageLimit: 10,
      search: '',
      from: null,
      to: null,
      sort: 'newest',
      bookings: [],
    };
  },

  mounted() {
    // eslint-disable-next-line
    for (let i = 0; i < fake.length; i++) {
      this.bookings.push(fake[i]);
    }
  },
};
</script>

<style lang="scss" scoped>
$main: #24a0ff;

.icon-label {
  color: $main;
  cursor: pointer;
  font-size: 14px;
}

.icon {
  color: $main !important;
  font-size: 18px !important;
}

.cta {
  display: flex;
  margin-bottom: 1rem;

  @media screen and (min-width: 75em) {
    margin-bottom: 0;
  }
}

.finder {
  display: flex;
  margin-bottom: 1rem;
  justify-content: center;

  @media screen and (min-width: 75em) {
    justify-content: flex-start;
    margin-bottom: 0;
  }
}

.content-wrapper {
  overflow: hidden;
  border: 1px solid #dedede;
  border-radius: 4px;
}

.summary-info {
  background-color: #dedede;
}

.table-header {
  background-color: #f1f2f3;
}
</style>
